import React from 'react';
import { Card, CardContent, Box, Typography, Stack } from '@mui/material';

/**
 * Card-based row rendering for admin list tables on phone-width screens, so a
 * row's data and actions never require horizontal scrolling to reach.
 *
 * avatar: optional ReactNode (e.g. <Avatar>X</Avatar>)
 * title / subtitle: ReactNode shown at the top of the card
 * fields: [{ label, value }] rendered as label/value rows below the header
 * actions: ReactNode (e.g. <RowActionsMenu .../>), right-aligned at the bottom
 */
const MobileEntityCard = ({ avatar, title, subtitle, fields = [], actions }) => (
  <Card variant="outlined" sx={{ mb: 1.5 }}>
    <CardContent sx={{ '&:last-child': { pb: 2 } }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        {avatar}
        <Box sx={{ minWidth: 0, flex: 1, overflowWrap: 'anywhere' }}>
          <Typography variant="subtitle2">{title}</Typography>
          {subtitle}
        </Box>
      </Box>
      {fields.length > 0 && (
        <Stack spacing={0.5} sx={{ mt: 1.5 }}>
          {fields.filter(Boolean).map((f, i) => (
            <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
              <Typography variant="caption" color="text.secondary">{f.label}</Typography>
              <Typography variant="body2" component="div" sx={{ textAlign: 'right', minWidth: 0, overflowWrap: 'anywhere' }}>{f.value}</Typography>
            </Box>
          ))}
        </Stack>
      )}
      {actions && (
        <Box sx={{ mt: 1.5, display: 'flex', justifyContent: 'flex-end' }}>
          {actions}
        </Box>
      )}
    </CardContent>
  </Card>
);

export default MobileEntityCard;
